import { utilsSeeks } from 'src/playerDomain/components/seeks/index';
import Utils from 'src/utils/Utils';
import TvChannelUtil from 'src/utils/TvChannelUtil';
import logger from 'src/utils/logger/logger';

const handleUpdatePlayer = (timeshiftData, _this) => {
    _this.switchingBetweenEventTimeshift = true;
    logger.debug('[NPC] function performTimeshift > ' + _this.switchingBetweenEventTimeshift);
    logger.debug('[NPC] ======================== RESET ============================');
    const currentTime = _this.getCurrentTime()
    _this.timeshiftTime = 0; // Reset
    const safeTime = _this.getSafeTime();
    const _begin = timeshiftData.timeshiftEvent.date_begin + safeTime;
    const _end = timeshiftData.timeshiftEvent.date_end;

    if (_this.props.doStartOver && Utils.isFunction(_this.props.doStartOver)) {
        _this.props.doStartOver(TvChannelUtil.getLastChannel(), _begin, _end, timeshiftData, true);
    }
    try {
        if (typeof _this.props.onUpdateCurrentTimeshift === 'function') {
            _this.props.onUpdateCurrentTimeshift(currentTime);
        }
    } catch (error) {
        logger.error('[NPC] Error on timeshift ', error);
    }
};

/* Función que se llama cuando es usuario TS y hace un seek en Live y los controles cambian de LiveTS a StartOver */
const performTimeshift = async (timeshiftData, _this) => {
    // Nueva experiencia
    if (_this.hasTimeshift()) {
        await utilsSeeks.sendForwardRewindSeek(timeshiftData, _this);

        handleUpdatePlayer(timeshiftData, _this);
    }
};

export const utilsPlayersControls = {
    performTimeshift,
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/utils/functions.js